// Encre bleu nuit froide, deux accents à chroma identique : périwinkle et menthe.
// Zéro orange — c'était une demande explicite, et c'est aussi ce qui évite la teinte
// « appli de paris sportifs ». Les deux thèmes sont de vrais thèmes, pas un filtre
// inversé : le clair est calibré pour être lisible en plein soleil dans une tribune.

export const SOMBRE = {
  '--bg': '#0c0e13', '--surf': '#151821', '--surf2': '#1e222d', '--line': '#2b3040',
  '--ink': '#f3f5f9', '--ink2': '#99a1b3', '--ink3': '#5d6575',
  '--acc': 'oklch(0.76 0.15 265)', '--acc2': 'oklch(0.76 0.15 158)',
  '--warn': 'oklch(0.76 0.15 75)', '--bad': 'oklch(0.68 0.18 25)',
  '--pitch': '#10141b', '--pline': 'rgba(255,255,255,.11)', '--tokink': '#0b0e14',
  '--ombre': '0 8px 24px rgba(0,0,0,.45)',
};

export const CLAIR = {
  '--bg': '#f5f5f3', '--surf': '#ffffff', '--surf2': '#eceef1', '--line': '#e0e2e7',
  '--ink': '#111318', '--ink2': '#6b7280', '--ink3': '#9aa1ad',
  '--acc': 'oklch(0.52 0.16 265)', '--acc2': 'oklch(0.44 0.12 158)',
  '--warn': 'oklch(0.58 0.13 75)', '--bad': 'oklch(0.55 0.18 25)',
  '--pitch': '#e6e8e4', '--pline': 'rgba(0,0,0,.14)', '--tokink': '#ffffff',
  '--ombre': '0 8px 24px rgba(0,0,0,.12)',
};

export const TONS = { bon: 'var(--acc2)', attention: 'var(--warn)', mauvais: 'var(--bad)' };

export function appliquerTheme(nom) {
  const vars = nom === 'clair' ? CLAIR : SOMBRE;
  const racine = document.documentElement;
  for (const [k, v] of Object.entries(vars)) racine.style.setProperty(k, v);
  racine.style.colorScheme = nom === 'clair' ? 'light' : 'dark';
  // La barre d'état d'iOS lit cette balise. Sans mise à jour, basculer en thème clair
  // laisse une bande noire en haut de l'écran, que rien dans la page n'explique.
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', vars['--bg']);
}
